import S3UploadFile from './S3UploadFile';

export default S3UploadFile;
